export default "__VITE_ASSET__BuZCb7XJ__"